module.exports = __webpack_public_path__ + "fonts/eb1a69007d5025a44cd5d6b742eb1ce6.woff2";